import { type FunctionComponent } from 'react';
import { type ArticleNavItemFieldsFragment } from '../../../__generated__/graphql-client-types';
import { Link } from '../../common-components/link/link.component';

export type LearningCenterNavProps = {
	rooms: ArticleNavItemFieldsFragment[];
	topics: ArticleNavItemFieldsFragment[];
};
export type NavListProps = {
	items: ArticleNavItemFieldsFragment[];
	heading: string;
};

const NavList: FunctionComponent<NavListProps> = ({ items, heading }) => (
	<>
		<div className={`flex items-center pt3 pb2 bb b--theme-grey-light`}>
			<h2 className="mv0 f4 lh-title">{heading}</h2>
		</div>
		{items.map((item) => (
			<div className={'mt3'} key={item.keyword}>
				<Link
					className={'db theme-grey-darker'}
					url={`/learn/${heading === 'Room' ? 'room' : 'topic'}/${item.keyword}`}
					underlineHover={true}
					ariaLabel={`${item.label} Articles`}>
					{item.label}
				</Link>
			</div>
		))}
	</>
);
export const LearningCenterNav: FunctionComponent<LearningCenterNavProps> = ({ rooms, topics }) => (
	<div>
		<NavList items={rooms} heading={'Room'} />
		<NavList items={topics} heading={'Article Type'} />
	</div>
);
